var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1719 27.0181C17.3335 27.0181 17.4927 26.9877 17.6424 26.9244C17.7922 26.8636 17.9256 26.7722 18.0404 26.6577L27.6383 17.0597C27.753 16.945 27.842 16.8116 27.9052 16.6618C27.966 16.5119 27.9988 16.3527 27.9988 16.1913C27.9988 16.0297 27.966 15.8705 27.9052 15.7207C27.8442 15.5709 27.753 15.4374 27.6383 15.3227L18.0404 5.72721C17.9256 5.61249 17.7922 5.52355 17.6424 5.46033C17.4927 5.39947 17.3335 5.3667 17.1719 5.3667V27.0181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8245 22.9777C15.5109 22.9777 15.1972 22.9028 14.956 22.753L5.35816 16.7367C4.88061 16.437 4.88061 15.9502 5.35816 15.6482L14.956 9.63196C15.1948 9.48214 15.5085 9.40723 15.8245 9.40723V22.9777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8245 18.9205C15.5109 18.9205 15.1972 18.8456 14.956 18.6959L5.35816 12.6796C4.88061 12.38 4.88061 11.893 5.35816 11.5911L14.956 5.57483C15.1948 5.42267 15.5085 5.3501 15.8245 5.3501V18.9205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8245 27.0343C15.5109 27.0343 15.1972 26.9595 14.956 26.8095L5.35816 20.7934C4.88061 20.4937 4.88061 20.0068 5.35816 19.7049L14.956 13.6886C15.1948 13.5388 15.5085 13.4639 15.8245 13.4639V27.0343Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalt);
export default __webpack_public_path__ + "static/media/talt.95638fef157b774915583a978139b8d7.svg";
export { ForwardRef as ReactComponent };